
































import { computed, defineComponent, PropType } from '@nuxtjs/composition-api';
import CardSection from '@shared/components/CardSection/CardSection.vue';
import Container from '@shared/components/Container/Container.vue';
import ProductCard from '@shared/components/ProductCard/ProductCard.vue';
import useUiHelpers from '@shared/composables/useUiHelpers';
import { ISBLink } from '@shared/types/storyblok';
import { Product, productGetters } from '@unified-commerce/gpc-vue-storefront-shopify';

import { HIDDEN_PRODUCT_TAG } from '~/constants';

import { productResultToProductCard } from '../ProductCard/utils/helpers';

export default defineComponent({
  name: 'ProductCarousel',
  components: {
    CardSection,
    ProductCard,
    Container,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    button_link: {
      type: [Object, String],
      default: '',
    },
    // eslint-disable-next-line vue/prop-name-casing
    button_text: {
      type: String,
      default: '',
    },
    products: {
      type: Array as PropType<Product[]>,
      default: () => [],
    },
    // TODO choose either `button` or `link` field name in Storyblok
    // eslint-disable-next-line vue/prop-name-casing
    link: {
      type: [Object, String],
      default: '',
    },
    // TODO choose either `button_text` or `link_text` field name in Storyblok
    // eslint-disable-next-line vue/prop-name-casing
    link_text: {
      type: String,
      default: '',
    },
    // TODO choose either `items` or `products` field name in Storyblok
    items: {
      type: Array as PropType<Product[]>,
      default: () => [],
    },
  },
  setup(props) {
    const { getCTALink } = useUiHelpers();

    const backwardsCompatibleProducts = props.products.length ? props.products : props.items;

    const filteredProducts = backwardsCompatibleProducts.filter(
      (item: any) => productGetters.isProduct(item) && !item.tags?.includes(HIDDEN_PRODUCT_TAG),
    );

    const mapProductToCard = (product: Product) => {
      return productResultToProductCard({ product });
    };

    const computedLink = computed(() =>
      getCTALink((props.button_link || props.link) as string | ISBLink),
    );

    const computedLinkText = computed(() => props.button_text || props.link_text);

    return {
      computedLink,
      computedLinkText,
      productGetters,
      filteredProducts,
      mapProductToCard,
    };
  },
});
